/**
 * feature-config flag names owned by area-design-system
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const DESIGN_SYSTEM_FLAG_NAMES = {
  DESIGNER_LIGHT_MODE: 'ff-ds-895-designer-light-mode',
  DESIGNER_LIGHT_MODE_DEFAULT_THEME:
    'ff-ds-3684-designer-light-mode-default-theme',
  DESIGN_SYSTEM_INSPECTOR: 'ff-ds-1682-design-system-inspector',
  DESIGN_SYSTEM_INSPECTOR_DASHBOARD: 'ff-ds-2710-dsi-dashboard',
  GLOBAL_INTERFACE_SETTINGS: 'ff-ds-3759-global-interface-settings',
  BUILDING_BLOCKS_POPOVERS: 'ff-dsys-7107-popovers',
  DESIGNER_FONT_PICKER_INSTALLED_ONLY:
    'ff-ds-7396-designer-font-picker-installed-only',
  LIBRARY_MANAGEMENT_PUBLIC_API: 'ff-ds-7362-library-management-public-api',
};
